// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Star Systems Configuration - Universe L-Space
 * 
 * L-Space (Library Space) - where all libraries are connected across space and time.
 * A dimension of pure knowledge where books have mass and can create gravity wells.
 * The Librarian's domain. Ook!
 */

export const starSystems = [
  {
    id: 700,
    name: 'THE GREAT LIBRARY',
    distance: 0, // Starting system
    threat: 'KNOWLEDGE OVERLOAD',
    resources: 'INFINITE BOOKS',
    services: ['refuel', 'trade', 'weapons', 'upgrades', 'modules'],
    description: 'The central nexus of all libraries. Every book ever written exists here. Ook!',
    primaryColor: '#8B4513',
    secondaryColor: '#FFD700',
    hasRings: false,
    animated: true,
  },
  {
    id: 701,
    name: 'ALEXANDRIA ETERNAL',
    distance: 50,
    threat: 'ANCIENT KNOWLEDGE',
    resources: 'SCROLLS & WISDOM',
    services: ['refuel', 'trade', 'exploration'],
    description: 'The Library of Alexandria, preserved forever in L-Space. It never burned here.',
    primaryColor: '#DAA520',
    secondaryColor: '#F4A460',
    hasRings: false,
    animated: true,
  },
  {
    id: 702,
    name: 'BABEL TOWER',
    distance: 75,
    threat: 'LINGUISTIC CHAOS',
    resources: 'ALL LANGUAGES',
    services: ['refuel', 'trade', 'weapons'],
    description: 'A tower of infinite stories, each containing every book in every language.',
    primaryColor: '#CD853F',
    secondaryColor: '#DEB887',
    hasRings: false,
    animated: true,
  },
  {
    id: 703,
    name: 'THE FORBIDDEN SECTION',
    distance: 100,
    threat: 'DANGEROUS KNOWLEDGE',
    resources: 'DARK TOMES',
    services: ['refuel', 'weapons', 'exploration'],
    description: 'Books that should never be read. The Necronomicon is filed under "N".',
    primaryColor: '#4B0082',
    secondaryColor: '#8B008B',
    hasRings: false,
    animated: true,
  },
  {
    id: 704,
    name: 'DIGITAL ARCHIVES',
    distance: 90,
    threat: 'DATA CORRUPTION',
    resources: 'ELECTRONIC KNOWLEDGE',
    services: ['refuel', 'trade', 'upgrades'],
    description: 'Where all digital libraries converge. The internet is just a small corner here.',
    primaryColor: '#00CED1',
    secondaryColor: '#4169E1',
    hasRings: false,
    animated: true,
  },
  {
    id: 705,
    name: 'THE UNWRITTEN LIBRARY',
    distance: 120,
    threat: 'POTENTIAL STORIES',
    resources: 'UNFINISHED TALES',
    services: ['refuel', 'trade', 'exploration'],
    description: 'Books that were never written, stories that were never told. Pure potential.',
    primaryColor: '#9370DB',
    secondaryColor: '#BA55D3',
    hasRings: false,
    animated: true,
  },
  {
    id: 706,
    name: 'AKASHIC RECORDS',
    distance: 140,
    threat: 'COSMIC TRUTH',
    resources: 'UNIVERSAL MEMORY',
    services: ['refuel', 'trade', 'weapons', 'upgrades'],
    description: 'The cosmic library containing every event that has ever occurred.',
    primaryColor: '#FFD700',
    secondaryColor: '#FFA500',
    hasRings: true,
    animated: true,
  },
  {
    id: 707,
    name: 'THE BURNING LIBRARY',
    distance: 110,
    threat: 'ETERNAL FLAMES',
    resources: 'PHOENIX KNOWLEDGE',
    services: ['refuel', 'weapons'],
    description: 'A library that burns forever but is never consumed. Books rewrite themselves in the flames.',
    primaryColor: '#FF4500',
    secondaryColor: '#FF6347',
    hasRings: false,
    animated: true,
  },
  {
    id: 708,
    name: 'MEMORY PALACE',
    distance: 85,
    threat: 'FORGOTTEN THINGS',
    resources: 'LOST MEMORIES',
    services: ['refuel', 'trade', 'exploration'],
    description: 'Where forgotten memories become books. Your childhood imaginary friend has a shelf here.',
    primaryColor: '#DDA0DD',
    secondaryColor: '#EE82EE',
    hasRings: false,
    animated: true,
  },
  {
    id: 709,
    name: 'THE INFINITE BOOKSHELF',
    distance: 160,
    threat: 'ENDLESS RECURSION',
    resources: 'FRACTAL KNOWLEDGE',
    services: ['refuel', 'trade'],
    description: 'A bookshelf that contains itself. Every book is about the bookshelf, including this one.',
    primaryColor: '#708090',
    secondaryColor: '#778899',
    hasRings: false,
    animated: true,
  },
];

// Space Stations in the L-Space Universe
export const spaceStations = [
  {
    id: 750,
    name: 'LIBRARIAN\'S OUTPOST',
    distance: 25,
    threat: 'OOK!',
    resources: 'BANANAS & BOOKS',
    services: ['refuel', 'trade', 'weapons', 'upgrades', 'modules'],
    description: 'The Librarian\'s personal station. Don\'t call him a monkey. Ook!',
    type: 'station',
    animated: true,
  },
  {
    id: 751,
    name: 'READER\'S REST',
    distance: 60,
    threat: 'QUIET PLEASE',
    resources: 'PEACE & QUIET',
    services: ['refuel', 'trade', 'modules'],
    description: 'A quiet station for contemplation. Shh! No talking in the library.',
    type: 'station',
    animated: true,
  },
  {
    id: 752,
    name: 'BOOKBINDER\'S WORKSHOP',
    distance: 95,
    threat: 'PAPER CUTS',
    resources: 'RARE BINDINGS',
    services: ['refuel', 'trade', 'weapons', 'upgrades'],
    description: 'Where damaged books are repaired and new ones are bound. Smells of leather and glue.',
    type: 'station',
    animated: true,
  },
];

export const starPositions = starSystems.reduce((acc, system) => {
  if (system.coordinates) {
    acc[system.id] = system.coordinates;
  }
  return acc;
}, {});
